module.exports = __webpack_public_path__ + "static/media/sun-light-winter-solstice.9d28fe38.svg";